import './Home.css';
import React from "react";
import './Blog.css'
import './Logstash.css'


class Logstash extends React.Component {

    componentDidMount(){
        document.title = "Logstash filters overheads"
    }

    render() {
        return (
            <>
            <section className="blog-title">
                <h3>{this.props.title}</h3>
                <div className="blog-date">{this.props.postDate}</div>
            </section>
            <section>
                <div className="blog-date">
                    {this.props.date}
                </div>
            </section>
            <section className="content">
                <section className="post">
                    <p>
                        Logging is big part at any orgnization and <a href="https://www.babylonhealth.com/" target="_blank" rel="noreferrer" >Babylon</a> is not an exception. We have massive logging framework for compliance purpose.
                        We process around 8K qps logs in our kubernetes clusters.
                        <br/>
                        So you can imagine the scale for processing logs.
                        Being a healthcare firm, we are pretty strict about how we log and treat sensitive data.
                    </p>
                    <p>
                        Coming back to the original issue, how measurable the logstash filters can be?
                    </p>
                    <p>
                        Developers reported that their logs are missing in centralized logging for non-production cluster and something is wrong with logstash.                
                    <br />
                        <div className="blog_image">
                            <img src="./facepalm_simpson.png" alt="facepalm"/> 
                        </div>
                    <br/>
                        While looking at the Logstash grafana dashboard, There were heavy memory spikes hitting 14Gb bar per pod. 
                        Looking briefly at the version control to check if we had some deployment during the shutdown period, there was only log4j vulnerability fix for logstash.
                    <br/>
                    <div className="blog_image">
                            <img className="logstash-img" alt="logstasg-grafana" src="./logstash.png"/> 
                        </div>
                    <br/>
                        The below log error caught our eyes, which was specifically configured in <code>truncate</code>  filter. And as it says, there is an empty attribute in the array  
                    <pre>
                        <code className="code_highlight">
                        2022-01-06T12:56:29,855][ERROR][logstash.javapipeline][output_newrelic] Pipeline worker error, the pipeline will be stopped {':pipeline_id=>"output_newrelic", :error=>"(RuntimeError) Invalid FieldReference: `[access_log][request][http][query][]`", :exception=>Java::OrgJrubyExceptions::RuntimeError, :backtrace=>["org.logstash.ext.JrubyEventExtLibrary$RubyEvent.get(org/logstash/ext/JrubyEventExtLibrary.java:112)","usr.share.logstash.vendor.bundle.jruby.$2_dot_5_dot_0.gems.logstash_minus_filter_minus_truncate_minus_1_dot_0_dot_4.lib.logstash.filters.truncate.truncate(/usr/share/logstash/vendor/bundle/jruby/2.5.0/gems/logstash-filter-truncate-1.0.4/lib/logstash/filters/truncate.rb:93)", "usr.share.logstash.vendor.bundle.jruby.$2_dot_5_dot_0.gems.logstash_minus_filter_minus_truncate_minus_1_dot_0_dot_4.lib.logstash.filters.truncate.truncate(/usr/share/logstash/vendor/bundle/jruby/2.5.0/gems/logstash-filter-truncate-1.0.4/lib/logstash/filters/truncate.rb:101)", "org.jruby.RubyArray.each(org/jruby/RubyArray.java:1821)", "usr.share.logstash.vendor.bundle.jruby.$2_dot_5_dot_0.gems.logstash_minus_filter_minus_truncate_minus_1_dot_0_dot_4.lib.logstash.filters.truncate.truncate(/usr/share/logstash/vendor/bundle/jruby/2.5.0/gems/logstash-filter-truncate-1.0.4/lib/logstash/filters/truncate.rb:100)", "usr.share.logstash.vendor.bundle.jruby.$2_dot_5_dot_0.gems.logstash_minus_filter_minus_truncate_minus_1_dot_0_dot_4.lib.logstash.filters.truncate.truncate(/usr/share/logstash/vendor/bundle/jruby/2.5.0/gems/logstash-filter-truncate-1.0.4/lib/logstash/filters/truncate.rb:101)", "org.jruby.RubyArray.each(org/jruby/RubyArray.java:1821)", "usr.share.logstash.vendor.bundle.jruby.$2_dot_5_dot_0.gems.logstash_minus_filter_minus_truncate_minus_1_dot_0_dot_4.lib.logstash.filters.truncate.truncate(/usr/share/logstash/vendor/bundle/jruby/2.5.0/gems/logstash-filter-truncate-1.0.4/lib/logstash/filters/truncate.rb:100)'}"
                        </code>
                    </pre>

                        It leads to dependent filter <code>kv</code> in our logstash. When parsing fails for <code>kv</code>  filter, if <code>tag_on_failure</code> is set it won't throw any errors. 
                        But our below configuration did some tricks. 

                    <pre>
                        <code className="code_highlight">
                        ruby &#123; {"\n"}     
                        &#32;&#32;&#32;&#32;&#32;id &#61;&#62; "http_query-decode" {"\n"}   
                            code &#61;&#62; "event.set(&apos;[access_log][request][http][query]&apos;, event.get(&apos;[access_log][request][http][query]&apos;).transform_values&#123; |xs| [*xs].collect(&URI.method(:decode_www_form_component)) &#125;)" {"\n"}
                        &#125;
                        </code>
                    </pre>


                    Looked at <a href="https://stackoverflow.com/questions/30783879/whats-the-difference-between-cgi-unescape-and-uri-decode-www-form-component" rel="noreferrer" target="_blank">stackoverflow post</a>, there was similar kind of weird queries that were being logged and looked like silently the <code>[access_log][request][http][query][]</code> empty array was created.
                    <pre>
                        <code>
                        URI.decode_www_form_component('%xz') {"\n"}
                        # ArgumentError: invalid %-encoding (%xz)
                        </code>
                    </pre>


                    I didn't dig much into truncate filter codebase but seems there is a memory leak on an empty object which piled up and hammering logstash.
                    <br/>
                    Our main target was to reduce the resource usage for logstash causing frequent restarts and truncate filter was only enabled in the development environment. So we just removed the `truncate` filter.

                    <br/>
                    Feel free to tag on <a href="https://twitter.com/p__nitin" _target="_blank" rel="noreferrer">twitter </a> if you have queries or comments.

                    <br/><br/>Happy logstashing🪵
                    </p>

                </section>
            </section>
            </>
        )
    }
}

export default Logstash;
